// extracted by mini-css-extract-plugin
export default {"creativeStatusBlock":"CreativeStatusesCount_creativeStatusBlock__SST4m","wrapper":"CreativeStatusesCount_wrapper__36Jnq"};